import React from 'react';
import { Heart } from 'lucide-react';
import RedirectPage from '../components/RedirectPage';

const Donate = () => {
  return (
    <RedirectPage
      title="Support the Cardinals"
      description="You're being redirected to our secure donation page. The page will open in a new tab."
      url="https://checkout.square.site/merchant/ML9HV45KKJ6BX/checkout/SVWL6X5SEZ4JA32IJOEHWQOW"
      icon={<Heart className="w-8 h-8 text-[#8B0000]" />}
    />
  );
};

export default Donate;